/* eslint-disable no-alert */
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from '@/store/index';
import qs from 'qs';
import axiosApi from '@/utils/axios/api';

axios.defaults.withCredentials = true;
axios.defaults.contentType = 'application/json';

Vue.use(VueAxios, axios);

const apiDomain = process.env.VUE_APP_API_99_148; // 測試資料
// const apiDomain = process.env.VUE_APP_API_10_151; // 正式資料

const apiUrl = {
  ashx: `${apiDomain}/member/ashx/author/default.ashx`,
  memberInfo: `${apiDomain}/member/ashx/memberInfo.ashx`,
  bouns: `${apiDomain}/marketing/ashx/bardetail.ashx?act=GetAvailableBonusPoint`,
  shoppingCartCount: `${apiDomain}/datasite/shoppingcar.ashx`,
  dev: process.env.VUE_APP_API_SERVICE,
};

export default {
  data() {
    return {
      isAlertLogin: false,
    };
  },
  methods: {
    // ashx共用取得資料的方法，會根據傳入的data不同取得不同的資料回傳。
    // ashx若有errorMessage統一在這邊alert
    async request(data, method = 'post', url = apiUrl.ashx) {
      try {
        const token = store.getters['auth/getTokens']?.at;
        const response = await axios({
          method,
          url,
          data,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.errorMessage) {
          // if (response.data.errorMessage === '尚未登入，請重新登入') {
          //   if (this.isAlertLogin) return false;
          //   // alert('尚未登入，請重新登入');
          //   this.isAlertLogin = true;
          //   // window.location.href = '/author';
          //   return false;
          // }
          // alert(response.data.errorMessage);
          return false;
        }
        if (response.status === 204) {
          return null;
        }

        return response.data;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    /**
     * 作者後台共用新增 ELK 方法
     * @param {String} eventName 事件名稱
     * @param {Any} custom 自訂紀錄參數
     */
    async addElkLog(eventName, custom = '', url = apiUrl.ashx) {
      try {
        const formData = new FormData();
        formData.append('action', 'addelk');
        formData.append('event', eventName);
        formData.append('custom', custom);

        await axios({
          method: 'post',
          url,
          data: formData,
        });
      } catch (error) {
        console.log(error);
      }
    },

    // 取得會員資料
    async getMemberOldInfo() {
      const response = await axios({
        method: 'post',
        url: apiUrl.memberInfo,
        contentType: 'application/json; charset=utf-8',
        dataType: 'jsonp',
      });
      let res = response.data.replaceAll('(', '');
      res = res.replaceAll(')', '');
      res = res.replaceAll(';', '');
      if (res !== '') {
        const memberInfo = JSON.parse(res);
        store.dispatch('updateMemberInfo', {
          memberInfo,
        });

        store.dispatch('updateisGetMemberInfo', {
          isGetMemberInfo: true,
        });
      }
    },

    // 取得購物金
    async getBounsPointRequest(data) {
      try {
        const response = await this.axios({
          method: 'post',
          url: apiUrl.bouns,
          data,
          cache: false,
          async: true,
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
        });
        return response;
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    // 取得購物車商品數量
    async getShoppingCartCountRequest(data) {
      try {
        const response = await this.axios({
          method: 'post',
          url: apiUrl.shoppingCartCount,
          data,
          cache: false,
          async: true,
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
        });
        return response;
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    // 檢查登入者是否登入/作者/無敵帳號
    async getIsAuthor() {
      try {
        const data = await axiosApi.GET('/api/AuthorBackendTool/api/author/is-author');
        store.dispatch('updateIdentity', {
          identity: data,
        });
      } catch (error) {
        console.log(error);
        // 驗證失敗一律視為未登入，避免殘留舊身份導致權限誤放行
        store.dispatch('updateIdentity', {
          identity: { isLogin: false, isAuthor: false, isAdmin: false },
        });
      }
    },

    async getMemberInfo() {
      // @const {Object} data 會員資訊參數
      const data = {
        // eslint-disable-next-line max-len
        fields: '{ pCoin nickname image bio account { cellphone { number } } levelInfo{ level levelExp levelExpToNext } }',
      };

      const response = await axios.post(
        `${apiUrl.dev}/profile/graphql/query/member`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${store.getters['auth/getTokens'].at}`,
          },
        },
      );

      return response;
    },

    async getAuthorId(memberId) {
      try {
        const response = await axios.get(
          `/api/InvestmentNote/MtoAuthorId?mid=${memberId}`,
          {
            headers: {
              Authorization: `Bearer ${store.getters['auth/getTokens'].at}`,
            },
          },
        );
        return {
          status: response.status,
          data: response.data,
        };
      } catch (error) {
        const { status } = error.response;

        if (status === 404) {
          return {
            status,
            data: null,
            errorMessage: '作者不存在',
          };
        }

        return {
          status,
          data: null,
          errorMessage: '取得網址時發生錯誤',
        };
      }
    },

    async getAnonymousToken(clientId) {
      // eslint-disable-next-line no-return-await
      return await axios.post(
        `${apiUrl.dev}/token`,
        qs.stringify({
          grant_type: 'guest',
          client_id: clientId,
        }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      );
    },
  },
};
